import React, { Component, Fragment } from 'react';
import Picker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import 'react-datepicker/dist/react-datepicker.css';
registerLocale('pt-BR', ptBR);

class DatePicker extends Component {
  static defaultProps = {
    errors: null,
  };

  state = {
    className: 'form-control',
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors !== null) {
      this.setState({ className: 'form-control parsley-error' });
    } else {
      this.setState({ className: 'form-control' });
    }
  }

  render() {
    const { errors } = this.props;
    const { className } = this.state;
    return (
      <Fragment>
        <div className={className}>
          <Picker locale="pt-BR" {...this.props} />
        </div>

        {errors !== null && (
          <ul className="parsley-errors-list filled">
            {errors.map((error, index) => (
              <li className="parsley-required" key={index}>
                {error}
              </li>
            ))}
          </ul>
        )}
      </Fragment>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/Form/DatePicker/index.js